<script>
    export default {
        name: "ProductTypographyToggle",
        props: {
            text: String,
            isActiveState: Boolean,
        },
        data() {
            return {
                nameAction: "Развернуть",
            };
        },
        computed: {
            textButton() {
                return `${this.nameAction} ${this.text}`;
            },
        },
        watch: {
            isActiveState(state) {
                state ? (this.nameAction = "Развернуть") : (this.nameAction = "Свернуть");
            },
        },
        methods: {
            toggled() {
                this.$emit("toggled");
            },
        },
    };
</script>

<template>
    <button class="product-typography-button outline" @click="toggled">
        {{ textButton }}
        <svg
            class="product-typography-button__icon"
            :class="{ 'is-active': this.nameAction === 'Свернуть' }"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M4 7L8 10L12 7" stroke-linecap="round" />
        </svg>
    </button>
</template>

<style lang="scss">
    .product-typography-button {
        display: flex;
        align-items: center;
        margin-top: 16px;
        color: var(--product-toggle-color);
        font-family: var(--product-toggle-font);
        font-size: var(--product-toggle-size);
        font-weight: var(--product-toggle-weight);
        line-height: 24px;
        text-transform: var(--product-toggle-case);
        transition: 0.3s ease-in-out color;
        cursor: pointer;
        &:hover {
            color: var(--product-toggle-color--hover);
        }

        &:active {
            color: var(--product-toggle-color--active);
        }
    }

    .product-typography-button__icon {
        margin-left: 4px;
        stroke: currentColor;

        &.is-active {
            transform: rotate(180deg);
        }
    }
</style>
